import {createAction, props} from '@ngrx/store';
import {Channel} from '@automata/models/channel';

export const LoadChannels = createAction('[Channels] Load Start');
export const LoadChannelsComplete = createAction('[Channels] Load Complete', props<{channels: Channel[]}>());
